//client/src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RootLayout from './Layouts/Rootlayout';

// Import pages
import About from './pages/About';
import MassageTherapy from './pages/MassageTherapy';
import BookingPage from './pages/booking/BookingPage';
import BookingConfirmationPg from './pages/booking/BookingConfirmPage';
import OrderConfirmationPg from './pages/ecommerce/OrderConfirmPage';
import EcommercePage from './pages/ecommerce/EcommercePage';
import SpaFAQPage from './pages/SpaFAQPage';
import Academy from './pages/Academy';
import TermsofService from './pages/TermsofService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminDashboard from './pages/admin/AdminDashboard';


// Import components
import ScrollToTop from './Components/ScrollToTop';
import Home from './Components/Home';

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop /> {/* to scroll to top when navigating between pages */}
      <div className="min-h-screen bg-primary-lighter">
        <Routes>
          {/* Admin routes without navbar/footer */}
          <Route path="/admin/*" element={<AdminDashboard />} />
        
          {/* Other routes with navbar/footer */}
          <Route
            path="/*"
            element={
              <RootLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/massage-therapy" element={<MassageTherapy />} />
                  <Route path="/booking" element={<BookingPage />} />
                  <Route path="/booking-confirmation-pg" element={<BookingConfirmationPg />} />
                  <Route path="/order-confirmation-pg" element={<OrderConfirmationPg />} />
                  <Route path="/ecommerce" element={<EcommercePage />} />
                  <Route path="/faq" element={<SpaFAQPage />} />
                  <Route path="/academy" element={<Academy />} />
                  <Route path="/terms-of-service" element={<TermsofService />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  {/* Other routes that need navbar/footer */}
                </Routes>
              </RootLayout>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;


